import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by Leesona 861 Tackified, Gilbos Doubler, Mahan Oven, Ratera, and Sahm 230E machines

export default function CreelTensionRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = {target: {value: ""}};

   return (
      <Row className="mb-2">
         <ColPrompt title={"Creel Tension"} bold={true} description={"g"} />
         <ColValue size={2}>
            Min:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.creelTensionMin || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 1, 600, "creelTensionMin")
                     : handleInputRangeChange(defaultOnChangeVal, 1, 600, "creelTensionMin")
               }
            />
            {errorDivDefinitions.creelTensionMin && <ErrorDiv>1-600 only</ErrorDiv>}
         </ColValue>
         <ColValue size={2}>
            Max:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.creelTensionMax || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 1, 600, "creelTensionMax")
                     : handleInputRangeChange(defaultOnChangeVal, 1, 600, "creelTensionMax")
               }
            />
            {errorDivDefinitions.creelTensionMax && <ErrorDiv>1-600 only</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
